export default __webpack_public_path__ + "static/O0072-5e0baa812118721a3a17d6d943af39ce.png";